//import React from 'react';
import React from 'react';

import  {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory
} from 'react-router-dom';
//import './materialize.css';
import './style.css';



import Main from './home';
import Contact from './contactus';
import Donate from './donate';
import About from './aboutus';
import Forms from './forms';
import Formsview from './formsview';
import Evangelism from './evangelism';
import Products from './product';
import ScrollTop from './scrollToTop';
//import Profile from './profile';
import Footer from './footer';
import Logo from './img/home.png';
import Gallery from './gallery';
import clsx from 'clsx';
//import welcome from './img/air-con-compressor-not-working-hero-image.jpg';
//import logo from './img/user2.jpg';
import { makeStyles} from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Menu_ from '@material-ui/icons/Menu';


const useStyles = makeStyles((theme)=>({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
    displayer_small:{
        [theme.breakpoints.up('xs')]: {
        display:'flex',
        },
         [theme.breakpoints.up('sm')]: {
       display:'none',
        }
    },
    displayer_big:{
        [theme.breakpoints.up('xs')]: {
        display:'none',
        },
         [theme.breakpoints.up('sm')]: {
       display:'flex',
        }
    }
}));

// Navigation component for the drawer
const NavigationDrawer = ({ onClose }) => {
  const history = useHistory();
  const classes = useStyles();
  
  const menuItems = [
    { text: 'Home', path: '/' },
    { text: 'Outreach', path: '/outreach' },
    { text: 'Gallery', path: '/Gallery' },
    { text: 'About Us', path: '/about' },
    { text: 'Contact Us', path: '/contact' },
    { text: 'Donate', path: '/donate' },
    { text: 'Forms', path: '/form' }
  ];

  const handleItemClick = (path) => {
    history.push(path);
    onClose();
  };

  return (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: false,
      })}
      role="presentation"
    >
      <List>
        {menuItems.map((item, index) => (
          <ListItem button key={item.text} onClick={() => handleItemClick(item.path)}>
            <ListItemIcon></ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </div>
  );
};

const Menu = ()=>{
    
  const classes = useStyles();
  const [state, setState] = React.useState({left: false});

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const handleDrawerClose = () => {
    setState({ ...state, left: false });
  };


        
 
        
        
        

    return(
        
        <Router>
        <nav className="white" role="navigation" id='navbar'>
         <div className={classes.displayer_big} >
            <div className="nav-wrapper containe before" >
                <Link to="/" className="brand-logo logo-container"> <img src={Logo} className="logo_img" alt="" /></Link>
                <ul className="right hide-on-med-and-down">
                            
                    <li><Link to="/outreach">Outreach</Link></li>
                    <li><Link to="/evangelism">Evangelism</Link></li>
                    <li><Link to="/Gallery">Gallery</Link></li>
                    <li><Link to="/about">About Us</Link></li>
                    <li><Link to="/contact">Contact Us</Link></li>
                    <li><Link to="/donate">Donate</Link></li>
                    {/* <li><Link to="/forms">Forms</Link></li> */}

                </ul>
                
        
         </div>
         </div>
        
        <div>
       
        
        
        <div className={classes.displayer_small} style={{textAlign:'left', padding:10}}>
      {['left'].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button onClick={toggleDrawer(anchor, true)}><Menu_ /></Button>
          <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
            <NavigationDrawer onClose={handleDrawerClose} />
          </Drawer>
        </React.Fragment>
      ))}
      
      <span style={{marginLeft:'24%'}}>
         <img src={Logo} className="logo_img_small" alt="" />
      </span>
    </div>
        
        
        
        </div>
        </nav>
        
        
        <ScrollTop/>
       
        
        <Switch>
          <Route path="/outreach">
            <Products/>
          </Route>
          <Route path="/evangelism">
            <Evangelism/>
          </Route>   
          <Route path="/donate">
            <Donate/>
          </Route> 
        
        <Route path="/about">
            <About />
          </Route>
        
        <Route path="/gallery">
            <Gallery />
          </Route> 
       
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="/forms">
            <Forms />
          </Route>  
          <Route path="/formsview">
            <Formsview />
          </Route> 
          {/* <Route path="/paypal">
            <paypal />
          </Route> */}
          <Route path="/">
            <Main/>
          </Route>
        </Switch>
        
        
        
        <Footer/>
        </Router>
        
        
        
        
    )
    
}



export default Menu;